import React from 'react';
import { Link } from 'gatsby';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import FooterColumn from '@components/footer/FooterColumn';
import StoreList from '@components/footer/StoreList';
import SocialIcons from '@components/footer/SocialIcons';
import AboutUsList from '@components/footer/AboutUsList';
import LegalLinks from '@components/footer/LegalLinks';

function Footer() {
  return (
    <div className="bg-secondary mt-auto">
      <PageWrapper $background="inherit">
        <div className="flex flex-col items-stretch md:flex-row md:flex-wrap">
          <FooterColumn heading="Customer Care">
            <a
              href="https://www.petsafe.com/support/policies-and-terms/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-white leading-8 no-underline hover:underline"
            >
              Returns & Policies
            </a>
            <Link
              to="/contact-us"
              className="flex items-center text-white leading-8 no-underline hover:underline"
            >
              Contact Us
            </Link>
            <a
              href="https://www.petsafe.com/authorized-retailers/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-white leading-8 no-underline hover:underline"
            >
              Find A Retailer
            </a>
          </FooterColumn>
          <FooterColumn heading="Store">
            <StoreList />
          </FooterColumn>
          <FooterColumn heading="About Us">
            <AboutUsList />
          </FooterColumn>
          <FooterColumn heading="Connect With Us">
            <SocialIcons />
          </FooterColumn>
          <LegalLinks />
        </div>
      </PageWrapper>
    </div>
  );
}

export default Footer;
